module.exports = __webpack_public_path__ + "img/diners.f7b7cc0b.svg";